// extracted by mini-css-extract-plugin
module.exports = {"bg":"__9PROi_ui","page":"__8d_Ftpyz","headerImg":"qxpSUG96","mobile":"mXF_56Fz","container":"QSeUvD5b","qrcode":"lRagu_7x","img":"WB3dTl_T","stickyQrcode":"SIvHGe3h"};